import { Partial } from '@40seas/entities/common';
import { CreateAddressMatchDto } from './create.address.match.dto';

export class UpdateAddressMatchDto extends Partial(CreateAddressMatchDto) {}
